import React, {useState} from 'react';

import { AutoComplete, Input} from 'antd';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {faSearch} from '@fortawesome/pro-duotone-svg-icons';


  
const AutoCompleteSelect = ({icon = faSearch, 
    autoCompleteProps, 
    inputProps, 
    searchInterface, 
    onSelect = (v)=>{}, 
    auxButtons = null,
    innerRef
    
}) => {

    const [options, setOptions] = useState([]);

    const [loading, setLoading] = useState(false);

    const {dataStore, onSearch, onFilter} = searchInterface;

    const handleSearch = (value, data = null) => {
        if(data == null){
            data = dataStore;
        }
        setOptions(value ? onFilter(value, data) : []);
    };

    const onSelectHandle = (value) => {
        onSelect && onSelect(value);
    };

   
      
    return (
<Input.Group compact>


    <AutoComplete style={{
            width: 300,
        }}
        options={options}
        onSelect={onSelectHandle}
        onSearch={handleSearch}

        dropdownMatchSelectWidth={252}
        ref={innerRef}
        {...autoCompleteProps}
    >
        
        
            <Input.Search 
                
                placeholder="Digite Para Buscar" 
                enterButton={<FontAwesomeIcon icon={icon}></FontAwesomeIcon>} 
                onSearch={async (p) => {
                    setLoading(true);
                    try{
                        const a = await onSearch(p); 
                        handleSearch(p, a)
                    } catch(err){
                        console.log(err);
                    }
                    setLoading(false);
                }}
                
                {...inputProps}
                loading={loading} />
        
    </AutoComplete>
   {auxButtons}
</Input.Group>

    );
}

AutoCompleteSelect.defaultProps = {
    
}

export {AutoCompleteSelect};
 